<template lang="html">

  <div>

   <section class="intro-simulador container">
    <h2>¡Listo!</h2>
  </section>

  <section class="formulario-wrapper row-start container ais">

    <div class="contenedor-cerdo">

      <video playsinline id="video" preload loop autoplay muted data-aos="fade-in">
        <source :src="'/static/video/video-cerdo.mp4'" type="video/mp4">    
        </video>

      </div>

      <div class="formulario">

        <h4>En base a los datos introducidos ya tenemos un cálculo de cuánto te costará la luz con Iner y cuánto puedes ahorrar…</h4>
        <h4>Si quieres, indícanos tus datos y te enviamos tu estudio por email:</h4>

        <div class="contratacion-part row-start">

          <div class="contenedor-input -full"
          :fill="!!data.nombre" :error="(errors.has('nombre') && clicked)" @click="focus('nombre')">
          <input type="text" class="input-text"
          v-validate="'required'"
          v-model="data.nombre"
          autocomplete="name" 
          name="nombre"/>
          <label for="nombre">Nombre*</label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
        </div>

        <div class="contenedor-input -full"
        :fill="!!data.email" :error="(errors.has('email') && clicked)" @click="focus('email')"
        >
        <input type="text" class="input-text"
        v-validate="'required|email'"
        v-model="data.email"
        autocomplete="email" 
        name="email"/>
        <label for="">Email*</label>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
      </div>


      <div class="contenedor-check">
        <input type="checkbox" id="politica" v-validate="'required'" name="politica" v-model="data.politica">
        <label for="politica">He leído y acepto la <router-link :to="$t('enlaces.politica_privacidad')" rel="noopener" target="_blank">política de privacidad</router-link></label>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
      </div>

      <!-- <div class="contenedor-check">
        <input type="checkbox" id="comunicaciones" name="comunicaciones" v-model="data.newsletter">
        <label for="comunicaciones">Acepto recibir emails con información y promociones de Iner Energía</label>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('comunicaciones') }}</span>
      </div> -->

      <button class="btn -degree" :loading="loading" @click="validate">Ver resultado</button>

    </div>

  </div>

</section>


</div>

</template>

<script lang="js">

  import {mapActions} from 'vuex';

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  Vue.use(VeeValidate);

  export default  {
    name: 'formulario-personales',
    props : ['sim_id'],
    mounted(){
      this.data.sim_id = this.sim_id;
    },
    data(){
      return{
        clicked : false,
        loading : false,
        data : {
          nombre : '',
          email : '',
          sim_id: '',
          newsletter:true
        }
      }
    },
    methods:{
      ...mapActions(['sendPersonalesSimulacion']),
      validate(){
        this.clicked = true;

        this.$validator.validateAll().then(canSend => {
            if(canSend){
              this.loading = true;
              this.sendPersonalesSimulacion(this.data).then(r => {
                this.$emit('sended');
                this.$emit('setHasEmail');
                this.loading = false;
              }).catch(e =>{})
            }
          });

      },
      focus(where){
        document.querySelector(`*[name=${where}]`).focus();
        document.querySelector(`*[name=${where}]`).click();
      } 
    }
  }
</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';

  .contenedor-check{
    width: 100%;
  }

  .contenedor-cerdo{
    width: calc(100% - 600px);
    display: inline-block;

    video{
      width: 100%;
    }
  }


  .formulario{
    width: 100%;
    max-width: 600px;
    text-align: left;
  }
  
  .contratacion-part{
    padding-left: 0;
    max-width: 400px;
  }
  
  .contenedor-input[fill=true]{

    label{
      font-size: 14px;
      color: $orange;
      transform: translateY(-15px);
    }

  }
  

  @media screen and (max-width: 1110px){
    .formulario-wrapper{
      padding-bottom: 50px;
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/components/view-parts/simulador/formulario-personales.vue